import React, { useEffect } from 'react';
import { getCurrentAuthContext, clearOtherContextTokens, getToken, removeToken, removeUser } from '../services/auth';
import { devLog } from '../utils/devLog';

interface AuthContextManagerProps {
  children: React.ReactNode;
}

const AuthContextManager: React.FC<AuthContextManagerProps> = ({ children }) => {
  useEffect(() => {
    const currentContext = getCurrentAuthContext();
    
    devLog(`🔐 [AuthContextManager] Contexto detectado: ${currentContext}`);
    devLog(`🔐 [AuthContextManager] URL atual: ${window.location.href}`);
    
    // Limpar tokens de outros contextos para evitar conflitos
    clearOtherContextTokens(currentContext);
    
    // Verificar se há token no contexto atual
    const currentToken = getToken(currentContext);
    const oppositeContext = currentContext === 'admin' ? 'parish' : 'admin';
    const oppositeToken = getToken(oppositeContext);
    
    devLog(`🔐 [AuthContextManager] Token atual (${currentContext}):`, !!currentToken);
    devLog(`🔐 [AuthContextManager] Token oposto (${oppositeContext}):`, !!oppositeToken);
    
    // Se não há token no contexto atual mas há no oposto, limpar tudo
    if (!currentToken && oppositeToken) {
      devLog(`🧹 [AuthContextManager] Limpando todos os tokens - sem token no contexto atual`);
      removeToken('admin');
      removeUser('admin');
      removeToken('parish');
      removeUser('parish');
    }
    
    devLog(`🔐 [AuthContextManager] Tokens limpos para contexto: ${currentContext}`);
  }, []);

  return <>{children}</>;
};

export default AuthContextManager;
